import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "delete",
  "use": "delete-usage",
  "viewBox": "0 0 400 400",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 400 400\" id=\"delete\"><defs><style>#delete .cls-1{fill:none;stroke-linecap:round;stroke-miterlimit:10;stroke-width:13px}</style></defs><g id=\"delete_Layer_1\" data-name=\"Layer 1\"><path class=\"cls-1\" d=\"M110.58 289.42l178.84-178.84M289.42 289.42L110.58 110.58\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol